/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Admin_OfflineInputs */

const vi_print_admin_offline = /** @type {(inputs: Print_Admin_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối`)
};

/**

* @param {Print_Admin_OfflineInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_admin_offline = /** @type {((inputs?: Print_Admin_OfflineInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Admin_OfflineInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_admin_offline(inputs)
});